import React, { useCallback } from 'react';
import tw, { styled } from 'twin.macro';
import PropTypes from 'prop-types';

import { useMutation } from '@sopranodesign/pulse-hooks';
import {
  BotProvider,
  RecordTyping,
  ComposerProvider,
  ConverseMessages
} from '@sopranodesign/pulse-volt';

import {
  AgentTypingProvider,
  LiveChatDeliveryProvider
} from '../Providers/index';
import { flipDirection } from '../../../../../utils/index';
import {
  stopTyping as stopTypingApi,
  startTyping as startTypingApi,
} from '../../../../../api/index';
import AgentComposer from './AgentComposer';

const EmbedBody = styled.div`
  ${tw`py-4 px-4 md:px-4 flex-grow overflow-y-auto overflow-x-hidden`}
  background-color: rgb(250 250 253);
`;

const Wrapper = styled.div`
  ${tw`flex flex-col flex-grow`}
  height: 100%;
`;

const ComposerArea = styled.div`
  ${tw`w-full`}
`;

const Conversation = ({ ticket }) => {
  const subscriberId = ticket.subscriber.id;

  const { mutate: startTypingMutation } = useMutation({
    mutationFn: startTypingApi
  });

  const { mutate: stopTypingMutation } = useMutation({
    mutationFn: stopTypingApi
  });

  const startTyping = useCallback(() => {
    startTypingMutation(subscriberId);
  }, [startTypingMutation, subscriberId]);

  const stopTyping = useCallback(() => {
    stopTypingMutation(subscriberId);
  }, [stopTypingMutation, subscriberId]);

  return (
    <BotProvider
      name={`User #${subscriberId}`}
      initialMessages={ticket.subscriber.messages.map(flipDirection)}
      compareMessages={() => false}>
      <LiveChatDeliveryProvider ticket={ticket}>
        <AgentTypingProvider subscriber={ticket.subscriber}>
          <Wrapper>
            <EmbedBody>
              <ConverseMessages />
            </EmbedBody>

            {ticket.is_active && ticket.status === 'in_progress' && (
              <ComposerArea>
                <ComposerProvider>
                  <RecordTyping
                    enabled
                    startTyping={startTyping}
                    stopTyping={stopTyping}
                  />
                  <AgentComposer
                    subscriberId={subscriberId}
                    ticketId={ticket.id}
                  />
                </ComposerProvider>
              </ComposerArea>
            )}
          </Wrapper>
        </AgentTypingProvider>
      </LiveChatDeliveryProvider>
    </BotProvider>
  );
};

Conversation.propTypes = {
  ticket: PropTypes.shape({
    id: PropTypes.number.isRequired,
    status: PropTypes.string.isRequired,
    is_active: PropTypes.bool.isRequired,
    subscriber: PropTypes.shape({
      id: PropTypes.number.isRequired,
      messages: PropTypes.array.isRequired
    }).isRequired
  }).isRequired
};

export default Conversation;